import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';

import { DiagStackAvailableOTXSequence } from '@vi-iot/client';

import {
  BackupConfigurationResult,
  OtxGenericResponse,
  OtxGetDTCErrorSettingConditionResponseStructure,
  OtxProcedureFileName,
  OtxProcedureName,
  RestoreConfigurationResult,
} from './diag-stack-otx.model';

export namespace DiagStackOtxActions {
  export const getAvailableOtxSequences = createActionGroup({
    source: 'DIAG STACK OTX Get available OTX sequences ',
    events: {
      attempt: emptyProps(),
      success: props<{
        gatewaySerial: string;
        availableOtxSequences: DiagStackAvailableOTXSequence[];
      }>(),
      error: props<{
        availableOtxSequencesError: any;
      }>(),
      'sequence missing': emptyProps(),
    },
  });

  export const executeOtx_GetDTCErrorSettingCondition = createActionGroup({
    source: 'DIAG STACK OTX Execute otx GetDTCErrorSettingCondition sequence',
    events: {
      attempt: props<{
        otxProcedureName: OtxProcedureName;
        otxProcedureFileName: OtxProcedureFileName;
      }>(),
      success: props<{
        otxGetDTCErrorSettingConditionResult: OtxGenericResponse<
          OtxGetDTCErrorSettingConditionResponseStructure
        >;
      }>(),
      error: props<{
        otxGetDTCErrorSettingConditionError: any;
      }>(),
    },
  });

  export const triggerOtxVddsReadAgainAttempt = createAction(
    '[DIAG STACK OTX] Read otx vdds again attempt'
  );

  export const executeOtx_BackupConfiguration = createActionGroup({
    source: 'DIAG STACK OTX Execute otx BackupConfiguration sequence',
    events: {
      'attempt async': emptyProps(),
      attempt: emptyProps(),
      'invoke status check': props<{
        otxBackupConfigurationAsyncSchedulerId: string;
      }>(),
      'still running': emptyProps(),
      success: props<{
        otxBackupConfigurationResult: BackupConfigurationResult;
      }>(),
      error: props<{
        otxBackupConfigurationError: unknown;
      }>(),
    },
  });

  export const executeOtx_RestoreConfiguration = createActionGroup({
    source: 'DIAG STACK OTX Execute otx RestoreConfiguration sequence',
    events: {
      'attempt async': emptyProps(),
      attempt: emptyProps(),
      'invoke status check': props<{
        otxRestoreConfigurationAsyncSchedulerId: string;
      }>(),
      'still running': emptyProps(),
      success: props<{
        otxRestoreConfigurationResult: RestoreConfigurationResult;
      }>(),
      error: props<{
        otxRestoreConfigurationError: unknown;
      }>(),
    },
  });
}
